import { Component, OnInit, OnDestroy } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { DomainDefinitionService } from "../../../builder/services/domain-definition.service";
import { Subscription } from "rxjs";

import * as jp from "jsonpath/jsonpath";
import { ContextInteractionService } from '../../services/context-interaction.service';

@Component({
    selector: 'app-multiselect-checkbox',
    templateUrl: './multiselect-checkbox.component.html',
    styleUrls: ['./multiselect-checkbox.component.scss'],
    standalone: false
})
export class MultiselectCheckboxComponent extends BaseControlComponent implements OnInit, OnDestroy {
    static componentName = 'MultiselectCheckboxComponent';

    domainSubscription: Subscription;
    selectedItem: any;
    items: Array<any> = new Array<any>();

    constructor(public readonly domainService: DomainDefinitionService, public readonly contextService: ContextInteractionService) {
        super(contextService);
        
    }

    ngOnInit(): void {
        super.ngOnInit();

        if (!this.contextValue)
            this.setContextValue([]);

        if (this.contextValue && !this.contextValue.push) {
            let array: Array<any> = new Array<any>(this.contextValue);
            this.setContextValue(array);
        }

        if (!this.isEdit) {
            let config = this.componentData.config;

            if (config.customSource && config.customSource.enabled) {
                this.items = jp.value(this.componentContext, config.customSource.path) || [];
                this.items.forEach(item => {
                    item.checked = this.isChecked(item);
                });
                this.formGroup.controls[this.componentData.key].setValue(this.contextValue, { emitEvent: false });
                this.setDisplayValue();
            } else if (config.domain) {
                this.domainSubscription = this.domainService.getValues(config.domain).subscribe((data) => {
                    this.items = data;
                    this.items.forEach(item => {
                        item.checked = this.isChecked(item)
                    });
                    this.formGroup.controls[this.componentData.key].setValue(this.contextValue, { emitEvent: false });
                    this.setDisplayValue();
                }, (error) => {
                        this.items = [];
                        this.setDisplayValue();
                        console.log(error);
                });
            }              
        }
    }

    ngOnDestroy() {
        if (this.domainSubscription)
            this.domainSubscription.unsubscribe();
    }

    setDisplayValue(): void {
        let displayStr = "";
        this.items.filter(x => x.checked).forEach((x, index) => {
            if (index != 0)
                displayStr += ', ';
            displayStr += `${x[this.componentData.config.displayProperty]}`;
        });

        this.saveContextData(`${this.componentData.contextTarget}.displayValue`, displayStr);
    }

    updateContextValue(option: any, event: any): void {
        this.change();
        let item = option[this.componentData.config.idProperty];
        let currentIndex = this.contextValue.findIndex(x => x === item);

        if (currentIndex === - 1) {
            this.contextValue.push(item);
            option.checked = true;
        }
        else {
            option.checked = false;
            this.contextValue.splice(currentIndex, 1);
        }

        this.setContextValue(this.contextValue);
        this.formGroup.controls[this.componentData.key].setValue(this.contextValue, { emitEvent: false });
        this.setDisplayValue();

        this.validateControl();
        super.change();
    }

    isChecked(item: any): boolean {        
        return this.contextValue.indexOf(item[this.componentData.config.idProperty]) > -1;;
    }

    /**
    * Validates the control manually
    */
    public validateControl(): void {
        if (this.componentData.validator) {
            this.componentData.validator(this.formGroup.get(this.componentData.key));
        }
    }
}
